export const recipes = {
  total: 2,
  results: [
    {
      _id: 'recipe_hm5aardmww8ro',
      source: {
        createdAt: 1534893216299,
        modifiedAt: 1565024810016,
        title: '"No-Tuna" Salad (Chickpeas)',
        totalTime: 15,
        prepTime: 15,
        mealTypes: ['Lunch'],
        notes:
          'Instead of lemon juice, you can use 2 tablespoons pickle juice instead.\n\nNote: Mixture will keep covered in the refrigerator for 4-5 days, making it great to make-ahead for weekday lunches.',
        description: null,
        forMealPlans: [
          'mp_OPDSKR8eqriUY',
          'mp_j8aPk8PFEOGfy',
          'mp_a19xmk19avet0',
          'mp_g650rv3v8fx9b',
          'mp_vwdvgqeiz84fq',
          'mp_efq1crbxmpt4b',
          'mp_7zcckasi349f8',
          'mp_rq7higkhj7n4r',
          'mp_7a90be894e514',
          'mp_6a0571e4838e4',
          'mp_r2qkmib3ujzyo',
          'mp_k7yw9e7hr7723',
        ],
        recipeDetails: {},
        image:
          'https://living-plate.s3.amazonaws.com/images/recipes/recipe_hm5aardmww8ro/1522867189443.jpg?AWSAccessKeyId=AKIAXJH6Z5MSP46QXYVB&Expires=1623069572&Signature=DXIk6ZFqS7H99WsNFCeTiRkbxrQ%3D',
        servings: 4,
        elements: [
          {
            directions: {
              make: {
                steps: [
                  {
                    direction: 'Place the chickpeas in a mixing bowl mash with a fork or potato masher.',
                    image: null,
                  },
                  {
                    direction:
                      'Add tahini, mustard, maple syrup, red onion, celery, pickles, lemon or pickle juice, capers, salt and pepper, and sunflower seeds (if using). Toss well to coat. Adjust seasonings to taste.',
                    image: null,
                  },
                  {
                    direction: 'Lay whole leaves of lettuce on a platter.',
                    image: null,
                  },
                  {
                    direction: 'Scoop 1/4 of chickpea mixture into each lettuce cup. Top with tomato and additional onion if desired.',
                    image: null,
                  },
                ],
                minutes: 0,
              },
              prep: {
                steps: [
                  {
                    direction: 'Drain and rinse chickpeas, dice red onion, celery, pickles, chop capers, and thinly slice tomato.',
                    image: null,
                  },
                ],
                minutes: 0,
              },
            },
            ingredients: [
              {
                ndb: {
                  ndbNo: '16359',
                  description: 'Chickpeas (garbanzo beans, bengal gram), mature seeds, canned, drained, rinsed in tap water',
                  measurement: 'oz',
                  amount: 15,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'chickpeas',
                note: 'choose low-sodium or no salt added',
                nutrients: {
                  CHOCDF: {
                    value: 97.25,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 586.83,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.89,
                    unit: 'g',
                  },
                  FAT: {
                    value: 10.5,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 26.79,
                    unit: 'g',
                  },
                  NA: {
                    value: 901.51,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 29.94,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 17.01,
                    unit: 'g',
                  },
                },
                technique: 'drained and rinsed',
                unit: '(15 oz.) can',
              },
              {
                ndb: {
                  ndbNo: '12198',
                  description: 'Seeds, sesame butter, tahini, from raw and stone ground kernels',
                  measurement: 'Tbs',
                  amount: 3,
                },
                quantity: 3,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'tahini',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 11.79,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 256.5,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 3.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 21.6,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 4.19,
                    unit: 'g',
                  },
                  NA: {
                    value: 33.3,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 8.01,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'Tablespoons',
              },
              {
                ndb: {
                  ndbNo: 'x6605796',
                  description: 'dijon mustard',
                  measurement: 'tsp',
                  amount: 1,
                },
                quantity: 1,
                equivalency: 'or spicy brown mustard',
                groceryCategory: 'Dry Goods',
                item: 'Dijon mustard',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 1,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 10,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0,
                    unit: 'g',
                  },
                  NA: {
                    value: 135,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'Teaspoon',
              },
              {
                ndb: {
                  ndbNo: '19353',
                  description: 'Syrups, maple',
                  measurement: 'tbsp',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'maple syrup',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 13.41,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 52,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 0,
                    unit: 'g',
                  },
                  NA: {
                    value: 2.4,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 12.09,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'Tablespoon',
              },
              {
                ndb: {
                  ndbNo: '11282',
                  description: 'nions, raw',
                  measurement: 'cup, chopped',
                  amount: 0.25,
                },
                quantity: 0.25,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'onion, red',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 3.74,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 16,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.04,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.68,
                    unit: 'g',
                  },
                  NA: {
                    value: 1.6,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.44,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 1.7,
                    unit: 'g',
                  },
                },
                technique: 'diced',
                unit: 'Cup',
              },
              {
                ndb: {
                  ndbNo: '11143',
                  description: 'Celery, raw',
                  measurement: 'cup',
                  amount: 0.25,
                },
                quantity: 0.25,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'celery',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0.89,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 4.2,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.05,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.48,
                    unit: 'g',
                  },
                  NA: {
                    value: 24,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.21,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0.4,
                    unit: 'g',
                  },
                },
                technique: 'diced',
                unit: 'Cup',
              },
              {
                ndb: {
                  ndbNo: '11948',
                  description: 'Pickles, cucumber, sweet, low sodium (includes bread and butter pickles)',
                  measurement: 'cup, chopped or diced',
                  amount: 0.25,
                },
                quantity: 0.25,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'pickles',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 13.49,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 48.8,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.1,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.44,
                    unit: 'g',
                  },
                  NA: {
                    value: 7.2,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.15,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 10.67,
                    unit: 'g',
                  },
                },
                technique: 'diced',
                unit: 'Cup',
              },
              {
                ndb: {
                  ndbNo: '09152',
                  description: 'Lemon juice, raw',
                  measurement: 'lemon yields',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'lemon',
                note: 'for 2 tablespoons lemon juice',
                nutrients: {
                  CHOCDF: {
                    value: 3.31,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 10.56,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.12,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.14,
                    unit: 'g',
                  },
                  NA: {
                    value: 0.48,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.17,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 1.21,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: null,
              },
              {
                ndb: {
                  ndbNo: '02054',
                  description: 'Capers, canned',
                  measurement: 'tsp, drained',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'capers',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0.14,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 0.66,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.09,
                    unit: 'g',
                  },
                  NA: {
                    value: 67.31,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.07,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0.01,
                    unit: 'g',
                  },
                },
                technique: 'drained and loosely chopped',
                unit: 'Teaspoon',
              },
              {
                ndb: {},
                quantity: 0,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'salt',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 0,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0,
                    FAT: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 0,
                    FAT: 'g',
                  },
                  NA: {
                    value: 0,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0,
                    unit: 'g',
                  },
                },
                technique: 'to taste',
                unit: null,
              },
              {
                ndb: {
                  ndbNo: '12036',
                  description: 'Seeds, sunflower seed kernels, dried',
                  measurement: 'Tbs',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'sunflower seeds, unsalted',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 1.75,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 51.1,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.39,
                    unit: 'g',
                  },
                  FAT: {
                    value: 4.5,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 0.75,
                    unit: 'g',
                  },
                  NA: {
                    value: 0.79,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 1.82,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0.23,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'Tablespoon',
              },
              {
                ndb: {
                  ndbNo: '11250',
                  description: 'Lettuce, butterhead (includes boston and bibb types), raw',
                  measurement: 'leaf, large',
                  amount: 4,
                },
                quantity: 4,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'lettuce, Bibb',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 1.34,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 7.8,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.13,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.66,
                    unit: 'g',
                  },
                  NA: {
                    value: 3,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.81,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0.56,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'whole leaves',
              },
              {
                ndb: {
                  ndbNo: '11529',
                  description: 'Tomatoes, red, ripe, raw, year round average',
                  measurement: 'medium whole (2-3/5" dia)',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'tomato',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 4.78,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 22.14,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.25,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 1.48,
                    unit: 'g',
                  },
                  NA: {
                    value: 6.15,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 1.08,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 3.23,
                    unit: 'g',
                  },
                },
                technique: 'sliced',
                unit: null,
              },
            ],
          },
        ],
        tags: [
          {
            id: 2,
            name: 'TagName 1',
            description: 'desc',
            order: 3,
            isPublished: true,
            createdAt: '2021-05-26T21:38:38.514Z',
            updatedAt: '2021-06-01T09:13:20.170Z',
            createdBy: 1,
            updatedBy: 1,
            autoPopulated: true,
          },
        ],
      },
      highlight: {},
    },
    {
      _id: 'recipe_mc9zmjgaa8z50',
      source: {
        createdAt: 1550020296332,
        modifiedAt: 1550020296332,
        title: '4-Ingredient Miso Glazed Salmon',
        totalTime: 30,
        mealTypes: ['Lunch', 'Dinner', 'Side'],
        prepTime: 5,
        notes: '<p>Feel free to experiment with any type of firm fish - cod is our other favorite for this recipe!</p>',
        description: null,
        forMealPlans: [
          'mp_g650rv3v8fx9b',
          'mp_OPDSKR8eqriUY',
          'mp_efq1crbxmpt4b',
          'mp_b0g1028nzxcro',
          'mp_3pcwvmrow9swa',
          'mp_tLOcss566MOaZ',
          'mp_rq7higkhj7n4r',
          'mp_vwdvgqeiz84fq',
          'mp_7zcckasi349f8',
          'mp_7a90be894e514',
          'mp_6a0571e4838e4',
          'mp_r2qkmib3ujzyo',
          'mp_k7yw9e7hr7723',
        ],
        image:
          'https://living-plate.s3.amazonaws.com/images/recipes/recipe_mc9zmjgaa8z50/1550019812173.jpg?AWSAccessKeyId=AKIAXJH6Z5MSP46QXYVB&Expires=1623069448&Signature=SpPxIBI0KfDSDfHYgb8XqMFDTHo%3D',
        servings: 5,
        elements: [
          {
            directions: {
              make: {
                steps: [
                  {
                    direction: 'In a small saucepan, heat miso mixture until paste has dissolved.',
                    image: null,
                  },
                  {
                    direction: 'Let marinade cool a bit,  then pour over fish. Let sit 30 minutes, flipping after 15 minutes.',
                    image: null,
                  },
                  {
                    direction: 'Bake fish for 10 minutes. Garnish with sesame seeds before serving.',
                    image: null,
                  },
                ],
                minutes: 0,
              },
              prep: {
                steps: [
                  {
                    direction: 'Preheat oven to 350°F.',
                    image: null,
                  },
                  {
                    direction: 'Whisk together miso paste and vinegar.',
                    image: null,
                  },
                  {
                    direction: 'Place fish in a glass dish.',
                    image: null,
                  },
                ],
                minutes: 0,
              },
            },
            ingredients: [
              {
                ndb: {
                  ndbNo: '15236',
                  description: 'Fish, salmon, Atlantic, farmed, raw',
                  measurement: 'lb',
                  amount: 1.5,
                },
                quantity: 1.5,
                equivalency: 'or other fish',
                groceryCategory: 'Meat/Fish',
                item: 'salmon',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 374,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 1414.4,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 20.74,
                    unit: 'g',
                  },
                  FAT: {
                    value: 91.26,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 0,
                    unit: 'g',
                  },
                  NA: {
                    value: 401.2,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 138.86,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'Pounds',
              },
              {
                ndb: {
                  ndbNo: '16112',
                  description: 'Miso',
                  measurement: 'cup',
                  amount: 0.25,
                },
                quantity: 0.25,
                equivalency: 'we love chickpea miso',
                groceryCategory: 'Refrigerated',
                item: 'miso paste',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 17.44,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 136.13,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.7,
                    unit: 'g',
                  },
                  FAT: {
                    value: 4.13,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 3.71,
                    unit: 'g',
                  },
                  NA: {
                    value: 2563,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 8.79,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 4.26,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'cup',
              },
              {
                ndb: {
                  ndbNo: '02068',
                  description: 'Vinegar, red wine',
                  measurement: 'cup',
                  amount: 0.5,
                },
                quantity: 0.5,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'rice wine vinegar',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0.32,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 22.71,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0,
                    unit: 'g',
                  },
                  NA: {
                    value: 9.56,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.05,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'cup',
              },
              {
                ndb: {
                  ndbNo: '12023',
                  description: 'Seeds, sesame seeds, whole, dried',
                  measurement: 'tsp',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'sesame seeds',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0.7,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 17.19,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.21,
                    unit: 'g',
                  },
                  FAT: {
                    value: 1.49,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 0.35,
                    unit: 'g',
                  },
                  NA: {
                    value: 0.33,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.53,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0.01,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'teaspoon',
              },
            ],
          },
        ],
        tags: [
          {
            id: 3,
            name: 'TagName 2',
            description: 'desc',
            order: 3,
            isPublished: true,
            createdAt: '2021-05-26T21:38:38.514Z',
            updatedAt: '2021-06-01T09:13:20.170Z',
            createdBy: 1,
            updatedBy: 1,
            autoPopulated: true,
          },
        ],
      },
      highlight: {},
    },
    {
      _id: 'recipe_hm5aardmww8ro6666+',
      source: {
        createdAt: 1534893216355,
        modifiedAt: 1565024810487,
        title: 'Hidden recipe',
        totalTime: 15,
        prepTime: 15,
        notes:
          'Instead of lemon juice, you can use 2 tablespoons pickle juice instead.\n\nNote: Mixture will keep covered in the refrigerator for 4-5 days, making it great to make-ahead for weekday lunches.',
        description: null,
        forMealPlans: [
          'mp_OPDSKR8eqriUY',
          'mp_j8aPk8PFEOGfy',
          'mp_a19xmk19avet0',
          'mp_g650rv3v8fx9b',
          'mp_vwdvgqeiz84fq',
          'mp_efq1crbxmpt4b',
          'mp_7zcckasi349f8',
          'mp_rq7higkhj7n4r',
          'mp_7a90be894e514',
          'mp_6a0571e4838e4',
          'mp_r2qkmib3ujzyo',
          'mp_k7yw9e7hr7723',
        ],
        recipeDetails: {
          hidden: true,
        },
        image:
          'https://living-plate.s3.amazonaws.com/images/recipes/recipe_hm5aardmww8ro/1522867189443.jpg?AWSAccessKeyId=AKIAXJH6Z5MSP46QXYVB&Expires=1623069572&Signature=DXIk6ZFqS7H99WsNFCeTiRkbxrQ%3D',
        servings: 4,
        elements: [
          {
            directions: {
              make: {
                steps: [
                  {
                    direction: 'Place the chickpeas in a mixing bowl mash with a fork or potato masher.',
                    image: null,
                  },
                  {
                    direction:
                      'Add tahini, mustard, maple syrup, red onion, celery, pickles, lemon or pickle juice, capers, salt and pepper, and sunflower seeds (if using). Toss well to coat. Adjust seasonings to taste.',
                    image: null,
                  },
                  {
                    direction: 'Lay whole leaves of lettuce on a platter.',
                    image: null,
                  },
                  {
                    direction: 'Scoop 1/4 of chickpea mixture into each lettuce cup.  Top with tomato and additional onion if desired.',
                    image: null,
                  },
                ],
                minutes: 0,
              },
              prep: {
                steps: [
                  {
                    direction: 'Drain and rinse chickpeas, dice red onion, celery, pickles, chop capers, and thinly slice tomato.',
                    image: null,
                  },
                ],
                minutes: 0,
              },
            },
            ingredients: [
              {
                ndb: {
                  ndbNo: '16359',
                  description: 'Chickpeas (garbanzo beans, bengal gram), mature seeds, canned, drained, rinsed in tap water',
                  measurement: 'oz',
                  amount: 15,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'chickpeas',
                note: 'choose low-sodium or no salt added',
                nutrients: {
                  CHOCDF: {
                    value: 97.25,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 586.83,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.89,
                    unit: 'g',
                  },
                  FAT: {
                    value: 10.5,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 26.79,
                    unit: 'g',
                  },
                  NA: {
                    value: 901.51,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 29.94,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 17.01,
                    unit: 'g',
                  },
                },
                technique: 'drained and rinsed',
                unit: '(15 oz.) can',
              },
              {
                ndb: {
                  ndbNo: '12198',
                  description: 'Seeds, sesame butter, tahini, from raw and stone ground kernels',
                  measurement: 'Tbs',
                  amount: 3,
                },
                quantity: 3,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'tahini',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 11.79,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 256.5,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 3.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 21.6,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 4.19,
                    unit: 'g',
                  },
                  NA: {
                    value: 33.3,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 8.01,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'Tablespoons',
              },
              {
                ndb: {
                  ndbNo: 'x6605796',
                  description: 'Dijon mustard',
                  measurement: 'tsp',
                  amount: 1,
                },
                quantity: 1,
                equivalency: 'or spicy brown mustard',
                groceryCategory: 'Dry Goods',
                item: 'Dijon mustard',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 1,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 10,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0,
                    unit: 'g',
                  },
                  NA: {
                    value: 135,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'Teaspoon',
              },
              {
                ndb: {
                  ndbNo: '19353',
                  description: 'Syrups, maple',
                  measurement: 'tbsp',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'maple syrup',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 13.41,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 52,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 0,
                    unit: 'g',
                  },
                  NA: {
                    value: 2.4,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 12.09,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'Tablespoon',
              },
              {
                ndb: {
                  ndbNo: '11282',
                  description: 'Onions, raw',
                  measurement: 'cup, chopped',
                  amount: 0.25,
                },
                quantity: 0.25,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'onion, red',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 3.74,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 16,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.04,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.68,
                    unit: 'g',
                  },
                  NA: {
                    value: 1.6,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.44,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 1.7,
                    unit: 'g',
                  },
                },
                technique: 'diced',
                unit: 'Cup',
              },
              {
                ndb: {
                  ndbNo: '11143',
                  description: 'Celery, raw',
                  measurement: 'cup',
                  amount: 0.25,
                },
                quantity: 0.25,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'celery',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0.89,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 4.2,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.05,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.48,
                    unit: 'g',
                  },
                  NA: {
                    value: 24,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.21,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0.4,
                    unit: 'g',
                  },
                },
                technique: 'diced',
                unit: 'Cup',
              },
              {
                ndb: {
                  ndbNo: '11948',
                  description: 'Pickles, cucumber, sweet, low sodium (includes bread and butter pickles)',
                  measurement: 'cup, chopped or diced',
                  amount: 0.25,
                },
                quantity: 0.25,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'pickles',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 13.49,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 48.8,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.1,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.44,
                    unit: 'g',
                  },
                  NA: {
                    value: 7.2,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.15,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 10.67,
                    unit: 'g',
                  },
                },
                technique: 'diced',
                unit: 'Cup',
              },
              {
                ndb: {
                  ndbNo: '09152',
                  description: 'Lemon juice, raw',
                  measurement: 'lemon yields',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'lemon',
                note: 'for 2 tablespoons lemon juice',
                nutrients: {
                  CHOCDF: {
                    value: 3.31,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 10.56,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.12,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.14,
                    unit: 'g',
                  },
                  NA: {
                    value: 0.48,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.17,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 1.21,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: null,
              },
              {
                ndb: {
                  ndbNo: '02054',
                  description: 'Capers, canned',
                  measurement: 'tsp, drained',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'capers',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0.14,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 0.66,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.09,
                    unit: 'g',
                  },
                  NA: {
                    value: 67.31,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.07,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0.01,
                    unit: 'g',
                  },
                },
                technique: 'drained and loosely chopped',
                unit: 'Teaspoon',
              },
              {
                ndb: {},
                quantity: 0,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'salt',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 0,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0,
                    FAT: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 0,
                    FAT: 'g',
                  },
                  NA: {
                    value: 0,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0,
                    unit: 'g',
                  },
                },
                technique: 'to taste',
                unit: null,
              },
              {
                ndb: {},
                quantity: 0,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'pepper',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 0,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 0,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0,
                    FAT: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 0,
                    FAT: 'g',
                  },
                  NA: {
                    value: 0,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0,
                    unit: 'g',
                  },
                },
                technique: 'to taste',
                unit: null,
              },
              {
                ndb: {
                  ndbNo: '12036',
                  description: 'Seeds, sunflower seed kernels, dried',
                  measurement: 'Tbs',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Dry Goods',
                item: 'sunflower seeds, unsalted',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 1.75,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 51.1,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.39,
                    unit: 'g',
                  },
                  FAT: {
                    value: 4.5,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    FAT: 'g',
                  },
                  FIBTG: {
                    value: 0.75,
                    unit: 'g',
                  },
                  NA: {
                    value: 0.79,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 1.82,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0.23,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'Tablespoon',
              },
              {
                ndb: {
                  ndbNo: '11250',
                  description: 'Lettuce, butterhead (includes boston and bibb types), raw',
                  measurement: 'leaf, large',
                  amount: 4,
                },
                quantity: 4,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'lettuce, Bibb',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 1.34,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 7.8,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.01,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.13,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 0.66,
                    unit: 'g',
                  },
                  NA: {
                    value: 3,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 0.81,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 0.56,
                    unit: 'g',
                  },
                },
                technique: null,
                unit: 'whole leaves',
              },
              {
                ndb: {
                  ndbNo: '11529',
                  description: 'Tomatoes, red, ripe, raw, year round average',
                  measurement: 'medium whole (2-3/5" dia)',
                  amount: 1,
                },
                quantity: 1,
                equivalency: null,
                groceryCategory: 'Produce',
                item: 'tomato',
                note: null,
                nutrients: {
                  CHOCDF: {
                    value: 4.78,
                    unit: 'g',
                  },
                  CHOLE: {
                    value: 0,
                    unit: 'mg',
                  },
                  ENERC_KCAL: {
                    value: 22.14,
                    unit: 'kcal',
                  },
                  FASAT: {
                    value: 0.02,
                    unit: 'g',
                  },
                  FAT: {
                    value: 0.25,
                    unit: 'g',
                  },
                  FATRN: {
                    value: 0,
                    unit: 'g',
                  },
                  FIBTG: {
                    value: 1.48,
                    unit: 'g',
                  },
                  NA: {
                    value: 6.15,
                    unit: 'mg',
                  },
                  PROCNT: {
                    value: 1.08,
                    unit: 'g',
                  },
                  SUGAR: {
                    value: 3.23,
                    unit: 'g',
                  },
                },
                technique: 'sliced',
                unit: null,
              },
            ],
          },
        ],
        tags: [
          {
            id: 2,
            name: 'TagName 1',
            description: 'desc',
            order: 3,
            isPublished: true,
            createdAt: '2021-05-26T21:38:38.514Z',
            updatedAt: '2021-06-01T09:13:20.170Z',
            createdBy: 1,
            updatedBy: 1,
            autoPopulated: true,
          },
        ],
      },
      highlight: {},
    },
  ],
};
export const singleTagData = {
  total: 2,
  limit: 10,
  skip: 0,
  data: [
    {
      id: 1,
      name: 'All day recipe',
      description: 'Example of Description written here about the living plate diet recipe',
      order: 4,
      forMealPlans: [
        { mealPlanId: 'mp_g650rv3v8fx9b' },
        { mealPlanId: 'mp_OPDSKR8eqriUY' },
        { mealPlanId: 'mp_efq1crbxmpt4b' },
        { mealPlanId: 'mp_b0g1028nzxcro' },
        { mealPlanId: 'mp_rq7higkhj7n4r' },
      ],
      isPublished: false,
    },
    {
      id: 4,
      name: 'Recipe',
      description: 'Short Description',
      order: 3,
      forMealPlans: [],
      isPublished: true,
    },
  ],
};

export const createTag = {
  isPublished: false,
  id: 1,
  name: 'Name',
  order: 2,
  description: 'desc',
  createdBy: 1,
  updatedBy: 1,
};

export const addTag = [
  {
    id: 2,
    userId: 134,
    recipeId: 'recipe_cob3s45trqkc6',
    createdAt: '2021-12-03T06:25:02.420Z',
    updatedAt: '2021-12-03T06:25:02.420Z',
  },
  {
    id: 8,
    userId: 134,
    recipeId: 'recipe_k7m1t5esr6010',
    createdAt: '2021-12-03T06:26:04.243Z',
    updatedAt: '2021-12-03T06:26:04.243Z',
  },
];
